import { render, staticRenderFns } from "./WidgetFormDialog.vue?vue&type=template&id=a9f92012&scoped=true&"
import script from "./WidgetFormDialog.vue?vue&type=script&lang=js&"
export * from "./WidgetFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./WidgetFormDialog.vue?vue&type=style&index=0&id=a9f92012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f92012",
  null
  
)

export default component.exports